import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { QuotePageData } from '@cpak/adp-cpak-bff-service-models';
import { DialogOutletService } from './dialog-outlet';
import { OpenPropertiesModal } from '@cpak/interfaces';
import { RoutingUrls } from '@cpak/enums';

@Injectable({
  providedIn: 'root',
})
export class ContractPropertiesService extends DialogOutletService {
  private quoteData$ = new BehaviorSubject<QuotePageData | null>(null);
  private updatedQuoteData$ = new BehaviorSubject<QuotePageData | null>(null);
  private currencyLabel$ = new BehaviorSubject<string | null>(null);
  private quoteId = '';
  private navigateToPak = false;
  constructor(router: Router) {
    super(router, 'contractProperties');
  }

  public override onCloseModal(id = '', navigateToPak = false): void {
    this.navigateToPak = navigateToPak;
    this.quoteId = id;
    super.onCloseModal();
  }

  public onOpenPropertiesModal(config: OpenPropertiesModal): void {
    this.quoteId = '';
    this.currencyLabel$.next(config.currencyLabel || null);
    this.setQuoteData(config.quoteData || null);
    super.onOpenModal(config.id);
  }

  public override outletNavigation(
    activatedRoute: ActivatedRoute,
    outletStatus: string | null,
    featureUrl = './'
  ): void {
    const url = this.navigateToPak && this.quoteId ? `/${RoutingUrls.Quotes}/${this.quoteId}` : featureUrl;
    super.outletNavigation(activatedRoute, outletStatus, url, false);
  }

  public getQuoteData(): Observable<QuotePageData | null> {
    return this.quoteData$.asObservable();
  }

  public getUpdatedQuoteData(): Observable<QuotePageData | null> {
    return this.updatedQuoteData$.asObservable();
  }

  public getQuoteDataValue(): QuotePageData | null {
    return this.quoteData$.getValue();
  }

  public setQuoteData(data: QuotePageData | null): void {
    this.quoteData$.next(data);
  }

  public setUpdatedQuoteData(data: QuotePageData | null): void {
    this.updatedQuoteData$.next(data);
  }

  public getCurrencyLabel(): string | null {
    return this.currencyLabel$.getValue();
  }

  public clearQuoteData(): void {
    this.quoteData$.next(null);
    this.updatedQuoteData$.next(null);
  }

  public cleanupData(): void {
    this.currencyLabel$.next(null);
    this.navigateToPak = false;
  }
}
